import { render, staticRenderFns } from "./AllCompanyDataUpdateEscalations.vue?vue&type=template&id=05a45650&scoped=true&"
import script from "./AllCompanyDataUpdateEscalations.vue?vue&type=script&lang=js&"
export * from "./AllCompanyDataUpdateEscalations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a45650",
  null
  
)

export default component.exports